import { Component } from '@angular/core';
import { TOAST_KEYS } from '@shared/constants/toast-keys';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'chicilon-global-toast',
  imports: [ToastModule],
  templateUrl: './global-toast.component.html',
  styleUrl: './global-toast.component.scss'
})
export class GlobalToastComponent {
  toastGMessageKey = TOAST_KEYS.G_MESSAGE;
}
